// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Domain$ReactHooksTemplate = require("./domain.res.js");

function fetchDomains(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/domains", (function (param) {
                return Json_decode.field("domains", (function (param) {
                              return Json_decode.list(Domain$ReactHooksTemplate.decode, param);
                            }), param);
              }));
}

function deleteDomain(domain) {
  var domainId = String(Belt_Option.getExn(Domain$ReactHooksTemplate.id(domain)));
  return Http$ReactHooksTemplate.fetchPostJSON("/api/v1/domains/" + domainId + "/delete", {});
}

function reducer(state, action) {
  if (typeof state !== "object") {
    if (action.TAG === "DisplayList") {
      return {
              TAG: "FetchDomainCompleted",
              _0: action._0
            };
    } else {
      return state;
    }
  }
  if (action.TAG === "DisplayList") {
    return {
            TAG: "FetchDomainCompleted",
            _0: action._0
          };
  }
  var domainId = action._0;
  var updatedDomains = List.filter(function (domain) {
          return Caml_obj.notequal(Domain$ReactHooksTemplate.id(domain), domainId);
        })(state._0);
  return {
          TAG: "FetchDomainCompleted",
          _0: updatedDomains
        };
}

function DomainList(props) {
  var handleEditDomain = props.handleEditDomain;
  var handleAddDomain = props.handleAddDomain;
  var alertOnDelete = props.alertOnDelete;
  var match = React.useReducer(reducer, "FetchDomainInProgress");
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function (param) {
          Js_promise.then_((function (domains) {
                  return Promise.resolve(Curry._1(dispatch, {
                                  TAG: "DisplayList",
                                  _0: domains
                                }));
                }), fetchDomains());
        }), []);
  if (typeof state !== "object") {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    className: "w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"
                                  }),
                              JsxRuntime.jsx("span", {
                                    children: "Loading domains...",
                                    className: "text-gray-600"
                                  })
                            ],
                            className: "flex items-center space-x-3"
                          }),
                      className: "flex items-center justify-center py-20"
                    }),
                className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"
              });
  }
  var domains = state._0;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("span", {
                                              children: "📋",
                                              className: "text-lg"
                                            }),
                                        JsxRuntime.jsx("h2", {
                                              children: "Domain List",
                                              className: "text-lg font-bold text-gray-900"
                                            }),
                                        JsxRuntime.jsx("span", {
                                              children: String(List.length(domains)) + " domains",
                                              className: "inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-full"
                                            })
                                      ],
                                      className: "flex items-center space-x-2"
                                    }),
                                JsxRuntime.jsxs("button", {
                                      children: [
                                        JsxRuntime.jsx("span", {
                                              children: "+",
                                              className: "mr-2"
                                            }),
                                        "Add New Domain"
                                      ],
                                      className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                      onClick: (function (param) {
                                          Curry._1(handleAddDomain, undefined);
                                        })
                                    })
                              ],
                              className: "flex items-center justify-between"
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Manage your organization's domains and their configurations",
                              className: "text-sm text-gray-600 mt-1"
                            })
                      ],
                      className: "bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 border-b border-gray-200"
                    }),
                JsxRuntime.jsx("div", {
                      children: List.length(domains) > 0 ? JsxRuntime.jsxs("table", {
                              children: [
                                JsxRuntime.jsx("thead", {
                                      children: JsxRuntime.jsxs("tr", {
                                            children: [
                                              JsxRuntime.jsx("th", {
                                                    children: "Domain",
                                                    className: "text-left py-3 px-4 font-medium text-gray-700"
                                                  }),
                                              JsxRuntime.jsx("th", {
                                                    children: "Type",
                                                    className: "text-left py-3 px-4 font-medium text-gray-700"
                                                  }),
                                              JsxRuntime.jsx("th", {
                                                    children: "Status",
                                                    className: "text-left py-3 px-4 font-medium text-gray-700"
                                                  }),
                                              JsxRuntime.jsx("th", {
                                                    children: "Verification",
                                                    className: "text-left py-3 px-4 font-medium text-gray-700"
                                                  }),
                                              JsxRuntime.jsx("th", {
                                                    children: "Roles",
                                                    className: "text-left py-3 px-4 font-medium text-gray-700"
                                                  }),
                                              JsxRuntime.jsx("th", {
                                                    children: "Actions",
                                                    className: "text-left py-3 px-4 font-medium text-gray-700"
                                                  })
                                            ]
                                          }),
                                      className: "bg-gray-50 border-b border-gray-200"
                                    }),
                                JsxRuntime.jsx("tbody", {
                                      children: $$Array.of_list(List.map((function (domain) {
                                                  var match = Domain$ReactHooksTemplate.domainType(domain);
                                                  var tmp;
                                                  tmp = match === "Custom" ? "text-purple-700 bg-purple-100" : "text-green-700 bg-green-100";
                                                  var match$1 = Domain$ReactHooksTemplate.verificationStatus(domain);
                                                  var tmp$1;
                                                  switch (match$1) {
                                                    case "NotApplicable" :
                                                        tmp$1 = "text-gray-500 bg-gray-100";
                                                        break;
                                                    case "Pending" :
                                                        tmp$1 = "text-yellow-700 bg-yellow-100";
                                                        break;
                                                    case "Verified" :
                                                        tmp$1 = "text-green-700 bg-green-100";
                                                        break;
                                                    
                                                  }
                                                  return JsxRuntime.jsxs("tr", {
                                                              children: [
                                                                JsxRuntime.jsx("td", {
                                                                      children: JsxRuntime.jsxs("div", {
                                                                            children: [
                                                                              JsxRuntime.jsx("span", {
                                                                                    children: Domain$ReactHooksTemplate.name(domain),
                                                                                    className: "text-sm font-medium text-gray-900"
                                                                                  }),
                                                                              Domain$ReactHooksTemplate.defaultDomain(domain) ? JsxRuntime.jsx("span", {
                                                                                      children: "Default",
                                                                                      className: "inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-full"
                                                                                    }) : null
                                                                            ],
                                                                            className: "flex items-center space-x-2"
                                                                          }),
                                                                      className: "py-4 px-4"
                                                                    }),
                                                                JsxRuntime.jsx("td", {
                                                                      children: JsxRuntime.jsx("span", {
                                                                            children: Domain$ReactHooksTemplate.domainTypeToString(domain),
                                                                            className: "inline-flex items-center px-2 py-1 text-xs font-medium rounded-full " + tmp
                                                                          }),
                                                                      className: "py-4 px-4"
                                                                    }),
                                                                JsxRuntime.jsx("td", {
                                                                      children: Domain$ReactHooksTemplate.active(domain) ? JsxRuntime.jsx("span", {
                                                                              children: "Active",
                                                                              className: "inline-flex items-center px-2 py-1 text-xs font-medium text-green-700 bg-green-100 rounded-full"
                                                                            }) : JsxRuntime.jsx("span", {
                                                                              children: "Inactive",
                                                                              className: "inline-flex items-center px-2 py-1 text-xs font-medium text-gray-500 bg-gray-100 rounded-full"
                                                                            }),
                                                                      className: "py-4 px-4"
                                                                    }),
                                                                JsxRuntime.jsx("td", {
                                                                      children: JsxRuntime.jsx("span", {
                                                                            children: Domain$ReactHooksTemplate.verificationStatusToString(domain),
                                                                            className: "inline-flex items-center px-2 py-1 text-xs font-medium rounded-full " + tmp$1
                                                                          }),
                                                                      className: "py-4 px-4"
                                                                    }),
                                                                JsxRuntime.jsx("td", {
                                                                      children: JsxRuntime.jsxs("div", {
                                                                            children: [
                                                                              Domain$ReactHooksTemplate.surveyFeedbackDomain(domain) ? JsxRuntime.jsx("span", {
                                                                                      children: "Survey",
                                                                                      className: "inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded"
                                                                                    }) : null,
                                                                              Domain$ReactHooksTemplate.internalCommunicationDomain(domain) ? JsxRuntime.jsx("span", {
                                                                                      children: "Internal",
                                                                                      className: "inline-flex items-center px-2 py-1 text-xs font-medium text-indigo-700 bg-indigo-100 rounded"
                                                                                    }) : null,
                                                                              Domain$ReactHooksTemplate.systemGenerated(domain) ? JsxRuntime.jsx("span", {
                                                                                      children: "System",
                                                                                      className: "inline-flex items-center px-2 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded"
                                                                                    }) : null
                                                                            ],
                                                                            className: "flex flex-wrap gap-1"
                                                                          }),
                                                                      className: "py-4 px-4"
                                                                    }),
                                                                JsxRuntime.jsx("td", {
                                                                      children: JsxRuntime.jsxs("div", {
                                                                            children: [
                                                                              JsxRuntime.jsx("button", {
                                                                                    children: JsxRuntime.jsx("img", {
                                                                                          className: "h-4 w-4",
                                                                                          src: Image$ReactHooksTemplate.edit
                                                                                        }),
                                                                                    className: "p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-200",
                                                                                    title: "Edit domain",
                                                                                    onClick: (function (param) {
                                                                                        Curry._1(handleEditDomain, Belt_Option.getExn(Domain$ReactHooksTemplate.id(domain)));
                                                                                      })
                                                                                  }),
                                                                              Domain$ReactHooksTemplate.systemGenerated(domain) ? JsxRuntime.jsx("button", {
                                                                                      children: JsxRuntime.jsx("img", {
                                                                                            className: "h-4 w-4",
                                                                                            src: Image$ReactHooksTemplate.trashGrey
                                                                                          }),
                                                                                      className: "p-2 text-gray-300 cursor-not-allowed",
                                                                                      title: "Cannot delete system domain",
                                                                                      disabled: true
                                                                                    }) : JsxRuntime.jsx("button", {
                                                                                      children: JsxRuntime.jsx("img", {
                                                                                            className: "h-4 w-4",
                                                                                            src: Image$ReactHooksTemplate.trashGrey
                                                                                          }),
                                                                                      className: "p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200",
                                                                                      title: "Delete domain",
                                                                                      onClick: (function (param) {
                                                                                          Js_promise.then_((function (response) {
                                                                                                  var domainId = Belt_Option.getExn(Domain$ReactHooksTemplate.id(domain));
                                                                                                  var status = Json_decode.field("status", (function (param) {
                                                                                                          return Json_decode.withDefault("error", Json_decode.string, param);
                                                                                                        }), response);
                                                                                                  if (status === "success") {
                                                                                                    Curry._1(dispatch, {
                                                                                                          TAG: "DeleteDomain",
                                                                                                          _0: domainId
                                                                                                        });
                                                                                                    Curry._1(alertOnDelete, {
                                                                                                          TAG: "Success",
                                                                                                          _0: "Domain deleted successfully"
                                                                                                        });
                                                                                                  } else {
                                                                                                    Curry._1(alertOnDelete, {
                                                                                                          TAG: "Failure",
                                                                                                          _0: "Failed to delete domain."
                                                                                                        });
                                                                                                  }
                                                                                                  return Promise.resolve();
                                                                                                }), deleteDomain(domain));
                                                                                        })
                                                                                    })
                                                                            ],
                                                                            className: "flex items-center space-x-2"
                                                                          }),
                                                                      className: "py-4 px-4"
                                                                    })
                                                              ],
                                                              className: "hover:bg-gray-50 transition-colors duration-150"
                                                            }, String(Belt_Option.getExn(Domain$ReactHooksTemplate.id(domain))));
                                                }), domains)),
                                      className: "divide-y divide-gray-200"
                                    })
                              ],
                              className: "w-full text-sm"
                            }) : JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("span", {
                                                  children: "🌐",
                                                  className: "text-2xl text-gray-400"
                                                }),
                                            className: "w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("h3", {
                                                    children: "No domains found",
                                                    className: "text-lg font-medium text-gray-900"
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "Get started by adding your first domain",
                                                    className: "text-sm text-gray-500 mt-1"
                                                  })
                                            ]
                                          }),
                                      JsxRuntime.jsxs("button", {
                                            children: [
                                              JsxRuntime.jsx("span", {
                                                    children: "+",
                                                    className: "mr-2"
                                                  }),
                                              "Add Your First Domain"
                                            ],
                                            className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                            onClick: (function (param) {
                                                Curry._1(handleAddDomain, undefined);
                                              })
                                          })
                                    ],
                                    className: "flex flex-col items-center space-y-4"
                                  }),
                              className: "text-center py-12"
                            }),
                      className: "overflow-x-auto"
                    })
              ],
              className: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"
            });
}

var make = DomainList;

exports.fetchDomains = fetchDomains;
exports.deleteDomain = deleteDomain;
exports.reducer = reducer;
exports.make = make;
/* react Not a pure module */
